var hierarchy = {
  compactBox: require('./compact-box'),
  dendrogram: require('./dendrogram'),
  indented: require('./indented'),
  mindmap: require('./mindmap')
};
module.exports = hierarchy;